import BaseApi from '../base';

class CheckupApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getCatalogs(token) {
    return this.makeRequest(this.METHOD_GET, 'catalogs', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getItems(token) {
    return this.makeRequest(this.METHOD_GET, `items`, token);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @returns {Promise<*>}
   */
  async getPrescriptions(token, id) {
    return this.makeRequest(this.METHOD_GET, `prescriptions?user=${id}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addPrescription(token, data) {
    return this.makeRequest(this.METHOD_POST, `prescriptions`, token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updatePrescription(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `prescriptions/${id}`, token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @returns {Promise<*>}
   */
  async getAnswers(token, id) {
    return this.makeRequest(this.METHOD_GET, `answers?user=${id}`, token);
  }
}

export default CheckupApi;
